import {
  CopyAll,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";
import {
  Button,
  Collapse,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SingleItemRevenueViewer from "./SingleRevenueViewer";

const SingleDateRevenueViewer = ({ date, items, file }) => {
  const [isOpen, setIsOpen] = useState(items.length <= 4);
  const [copyText, setCopyText] = useState("Copy");
  const [downloadText, setDownloadText] = useState("Download");

  const onCopyText = (isDownload) => {
    // excelGenerator({ date: bookings }, accountFormatter, file, isDownload);
    isDownload ? setDownloadText("Downloaded") : setCopyText("Copied");
    setTimeout(() => {
      isDownload ? setDownloadText("Download") : setCopyText("Copy");
    }, 2000);
  };

  const onToggle = () => {
    setIsOpen((p) => !p);
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{
          flexGrow: 1,
          justifyContent: "space-between",
          display: "flex",
        }}
      >
        <Button
          onClick={onToggle}
          disableRipple
          sx={{
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            textTransform: "none",
          }}
        >
          <Typography
            variant="h6"
            color="primary.main"
            sx={{ fontSize: "14px" }}
          >
            {date}
          </Typography>

          {isOpen ? (
            <KeyboardArrowUp sx={{ marginLeft: "20px" }} />
          ) : (
            <KeyboardArrowDown sx={{ marginLeft: "20px" }} />
          )}
        </Button>

        <div
          style={{
            marginRight: "30px",
          }}
        >
          <Tooltip title={downloadText} placement="left">
            <IconButton
              sx={{
                marginRight: "20px",
              }}
              onClick={() => {
                onCopyText(true);
              }}
            >
              <ArrowDownwardIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={copyText} placement="right">
            <IconButton
              onClick={() => {
                onCopyText(false);
              }}
            >
              <CopyAll />
            </IconButton>
          </Tooltip>
        </div>
      </Stack>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <div style={{ marginLeft: "10px" }}>
          {items.map((item) => {
            return <SingleItemRevenueViewer item={item} key={item.itemId} />;
          })}
        </div>
      </Collapse>
    </>
  );
};

export default SingleDateRevenueViewer;
